// App-vue 的 @message 可能在后退/销毁时才交付，返回不能等待 goback 消息。
// 原生宿主走 SDK 导航；浏览器 iframe 仍交给宿主校验消息并返回。
export function createOrderBackNavigation({ window: win, document: doc, goBrowserBack, onUnavailable }) {
  let pending = false;
  let disposed = false;
  let readyTimer = null;
  let retryTimer = null;

  function clearReadyWait() {
    doc.removeEventListener("UniAppJSBridgeReady", navigate);
    if (readyTimer !== null) win.clearTimeout(readyTimer);
    readyTimer = null;
  }

  function fail() {
    clearReadyWait();
    pending = false;
    if (!disposed) onUnavailable();
  }

  function navigate() {
    if (disposed || !pending) return;
    clearReadyWait();
    const sdk = win.uni && (win.uni.webView || win.uni);
    const isApp = !!(win.plus || win.__dcloud_weex_postMessage || win.__dcloud_weex_) ||
      /uni-app|Html5Plus/i.test(win.navigator.userAgent);
    try {
      if (isApp) {
        if (!sdk || typeof sdk.navigateBack !== "function") return fail();
        // 只发导航指令，不再先 postMessage，避免延迟的 goback 导致二次返回。
        sdk.navigateBack({ delta: 1 });
      } else if (win.parent !== win) {
        if (!sdk || typeof sdk.postMessage !== "function") return fail();
        sdk.postMessage({ data: { goback: 1 } });
      } else {
        goBrowserBack();
      }
      // SDK 导航没有成功/失败回调：拦截连点，但允许未离页时再次尝试。
      if (!disposed) {
        retryTimer = win.setTimeout(() => { pending = false; retryTimer = null; }, 800);
      }
    } catch (error) {
      fail();
    }
  }

  return {
    goBack() {
      if (disposed || pending) return;
      pending = true;
      const isApp = !!(win.plus || win.__dcloud_weex_postMessage || win.__dcloud_weex_) ||
        /uni-app|Html5Plus/i.test(win.navigator.userAgent);
      if ((!isApp && win.parent === win) || win.UniAppJSBridge) {
        navigate();
      } else {
        doc.addEventListener("UniAppJSBridgeReady", navigate);
        readyTimer = win.setTimeout(fail, 2000);
      }
    },
    dispose() {
      disposed = true;
      pending = false;
      clearReadyWait();
      if (retryTimer !== null) win.clearTimeout(retryTimer);
      retryTimer = null;
    },
  };
}
